module.exports = __webpack_public_path__ + "static/26gde-222f785937718c755ad6598e27aabbb8.gif";